// extracted by mini-css-extract-plugin
module.exports = {"newBg":"TrafficMessageSubjectText_newBg_7ETuP"};